export { PLUGIN_KEY, PLUGIN_PRIORITY, ManualColumnResize } from "./manualColumnResize.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/manualColumnResize/index.mjs
// module id = 1464
// module chunks = 1